import { render, staticRenderFns } from "./ParametrosFornecedorFormulario.vue?vue&type=template&id=e1d3434c&lang=pug"
import script from "./ParametrosFornecedorFormulario.vue?vue&type=script&lang=js"
export * from "./ParametrosFornecedorFormulario.vue?vue&type=script&lang=js"
import style0 from "./ParametrosFornecedorFormulario.vue?vue&type=style&index=0&id=e1d3434c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports